/**
 * First-time visitors must land on Thai, regardless of browser language.
 *
 * nuxt-i18n's detection order is cookie → navigator → fallback, and there is
 * no config flag to skip the navigator step while keeping cookie persistence
 * (setLocale only writes the cookie when detectBrowserLanguage is enabled).
 * So we seed the locale cookie to 'th' before the i18n plugin runs: the
 * cookie detector then wins and navigator is never consulted.
 *
 * The version marker also performs a one-time migration: builds before this
 * plugin auto-wrote the detected browser locale into the cookie, so past
 * visitors with English-language browsers were stuck on English without ever
 * choosing it. Anyone without the marker is reset to Thai once; after that,
 * manual switcher choices persist untouched. Bump the marker value to force
 * another one-time reset.
 */
export default defineNuxtPlugin({
  name: 'default-locale-th',
  enforce: 'pre',
  setup() {
    const expires = new Date()
    expires.setDate(expires.getDate() + 365)
    // Same cookie attributes nuxt-i18n uses, so it overwrites (not shadows) ours.
    const opts = { path: '/', expires, sameSite: 'lax' as const }
    const marker = useCookie('i18n_locale_v', opts)
    if (marker.value !== '1') {
      useCookie('i18n_locale', opts).value = 'th'
      marker.value = '1'
    }
  }
})
